<template>
  <div class="body-user">
    <vs-popup
      :title="$t('MY_ACCOUNT').Title"
      :active.sync="displayPopupMyAccount"
      class="my-account-modal-mobile"
      :style="insetStyle"
    >
      <my-account
        v-if="displayPopupMyAccount"
        @close="displayPopupMyAccount = !displayPopupMyAccount"
      ></my-account>
    </vs-popup>
    <vs-popup
      :title="$t('USER_SIGNATURE').Title"
      :active.sync="displayPopupSignatures"
      class="user-signatures-modal"
    >
      <user-signatures
        v-if="displayPopupSignatures"
        @close="displayPopupSignatures = !displayPopupSignatures"
      ></user-signatures>
    </vs-popup>
    <vs-popup
      :title="$t('PACKAGES').Title"
      :active.sync="displayPopupPackages"
      class="packages-modal"
    >
      <packages
        v-if="displayPopupPackages"
        @close="displayPopupPackages = !displayPopupPackages"
      ></packages>
    </vs-popup>
    <vs-popup
      :title="$t('USER_NOTIFICATION').Notification"
      :active.sync="displayPopupNotification"
      class="user-notification-modal"
    >
      <user-notification
        v-if="displayPopupNotification"
        @close="displayPopupNotification = !displayPopupNotification"
      ></user-notification>
    </vs-popup>
    <vs-popup
      :title="$t('CHANGE_PASSWORD').Title"
      :active.sync="displayPopupChangePassword"
      class="change-password-modal"
    >
      <change-password
        v-if="displayPopupChangePassword"
        @close="displayPopupChangePassword = !displayPopupChangePassword"
      ></change-password>
    </vs-popup>
    <vs-popup
      :title="$t('HELP_PRIVACY_POLICY').Title"
      :active.sync="displayPopupPrivacyPolicy"
      class="privacy-policy-modal"
    >
      <privacy-policy
        v-if="displayPopupPrivacyPolicy"
        @close="displayPopupPrivacyPolicy = !displayPopupPrivacyPolicy"
      ></privacy-policy>
    </vs-popup>

    <!-- <div class="mobile-user-header flex">
      <feather-icon
        icon="ChevronLeftIcon"
        @click.stop="$emit('back')"
        class="cursor-pointer mr-4 icon-back"
        svg-classes="w-6 h-6"
      ></feather-icon>
      <div class="title-page">{{$t('NAVBAR_DROPDOWN_MENU').My_Account}}</div>
    </div> -->
    <div class="pdf-viewer-mobile-popup-header" style="display: contents">
      <feather-icon
        icon="XIcon"
        @click.stop="$emit('back')"
        class="cursor-pointer mr-4 icon-back cursor-pointer"
        svg-classes="w-6 h-6"
      ></feather-icon>
      <!-- <span class="title-page">{{$t('NAVBAR_DROPDOWN_MENU').My_Account}}</span> -->
    </div>
    <div class="mobile-content-options">
      <div class="menu-user-mobile-header">
        <template v-if="isAuthenticated">
          <vs-avatar
            :text="getUserName"
            class="avatar"
            @click.stop="displayPopupMyAccount = !displayPopupMyAccount"
          ></vs-avatar>
          <!-- <vs-avatar :text="activeUserInfo.nome" class="avatar"></vs-avatar> -->
          <p>{{ activeUserInfo.nome }}</p>
          <p class="email">{{ activeUserInfo.email }}</p>
        </template>
        <template v-else>
          <div class="mr-4 custom-logo logo-full"></div>
        </template>
      </div>
      <div class="menu-space-blank" v-if="!isAuthenticated"></div>
      <ul class="ul-menu-user">
        <div class="lbl-cong" v-if="isAuthenticated">
          {{ $t("NAVBAR_DROPDOWN_MENU").Info_Account }}
        </div>
        <li
          v-if="!isAuthenticated"
          class="options-config flex"
          @click.stop="$emit('open-login')"
        >
          <feather-icon
            icon="UserIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("BUTTONS").Enter }}</div>
        </li>
        <li
          v-if="!isAuthenticated"
          class="options-config flex"
          @click.stop="$emit('open-register')"
        >
          <feather-icon
            icon="UserIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("BUTTONS").Register }}</div>
        </li>
        <!-- <li
          v-if="!isAuthenticated && !canDisplayOnMobileIOS"
          class="options-config flex"
          @click.stop="$emit('open-plans')"
        >
          <feather-icon
            icon="UserIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{$t('NAVBAR_DROPDOWN_MENU').Packages}}</div>
        </li> -->

        <li
          v-if="isAuthenticated"
          class="options-config flex"
          @click.stop="displayPopupMyAccount = !displayPopupMyAccount"
        >
          <feather-icon
            icon="UserIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").Profile }}</div>
        </li>
        <li
          class="options-config flex"
          @click="openUserSignaturesMobile"
          v-if="!canDisplayOnMobileIOS && isAuthenticated"
        >
          <feather-icon
            icon="ShoppingBagIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").Signatures }}</div>
        </li>
        <li
          class="options-config flex"
          @click="openPlans"
          v-if="!canDisplayOnMobileIOS && isAuthenticated"
        >
          <feather-icon
            icon="ShoppingBagIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").Packages }}</div>
        </li>
        <li
          class="options-config flex"
          @click="displayPopupNotification = !displayPopupNotification"
          v-if="isAuthenticated"
        >
          <feather-icon
            icon="BellIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").Notification }}</div>
        </li>
        <li
          class="options-config flex"
          @click="displayPopupChangePassword = !displayPopupChangePassword"
          v-if="isAuthenticated"
        >
          <feather-icon
            icon="KeyIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">
            {{ $t("NAVBAR_DROPDOWN_MENU").Change_Password }}
          </div>
        </li>
        <li
          class="options-config flex"
          @click="displayPopupPrivacyPolicy = !displayPopupPrivacyPolicy"
        >
          <feather-icon
            icon="FileTextIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">
            {{ $t("NAVBAR_DROPDOWN_MENU").Privacy_Policy }}
          </div>
        </li>
        <!-- <li class="options-config flex" @click="$emit('open-help')">
          <feather-icon
            icon="HelpCircleIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">Ajuda</div>
        </li> -->
        <li class="options-config flex" @click="$emit('open-attendance')">
          <feather-icon
            icon="HelpCircleIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").Help }}</div>
        </li>
        <li class="options-config flex" @click="$emit('open-quotes-config')">
          <feather-icon
            icon="SettingsIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").Quotes_Config }}</div>
        </li>
        <li class="options-config flex" @click="$emit('open-help')">
          <feather-icon
            icon="InfoIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").About }}</div>
        </li>
        <li
          class="options-config flex"
          @click="$emit('logout')"
          v-if="isAuthenticated"
        >
          <feather-icon
            icon="LogOutIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").Logout }}</div>
        </li>
        <div class="lbl-cong">
          {{ $t("NAVBAR_DROPDOWN_MENU").Platform_Config }}
        </div>
        <!-- <li
          class="options-config flex"
          v-if="isAuthenticated"
        >
          <feather-icon
            icon="SlidersIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">Habilitar FaceID ou Finger</div>
        </li> -->
        <li
          class="options-config flex"
          @click="displayPopupChangeFont = !displayPopupChangeFont"
        >
          <feather-icon
            icon="SlidersIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">Zoom</div>
          <div class="view-mode user" v-if="!isDesktop">
            <span
              class="icons-tools-wrap icons-tools-wrap-mobile btn-left"
              :class="{
                'view-style-selected-mobile': isPlatformZoomUltraCompact,
              }"
              @click.stop="$emit('update-platform-zoom-ultra-compact')"
            >
              80%
            </span>
            <span
              class="icons-tools-wrap icons-tools-wrap-mobile btn-center"
              :class="{ 'view-style-selected-mobile': isPlatformZoomCompact }"
              @click.stop="$emit('update-platform-zoom-compact')"
            >
              90%
            </span>

            <span
              class="icons-tools-wrap icons-tools-wrap-mobile btn-center"
              :class="{
                'view-style-selected-mobile':
                  isPlatformZoomDefault || !currentPlatformZoom,
              }"
              @click.stop="$emit('update-platform-zoom-default')"
            >
              100%
            </span>

            <span
              class="icons-tools-wrap icons-tools-wrap-mobile btn-right"
              :class="{ 'view-style-selected-mobile': isPlatformZoomBig }"
              @click.stop="$emit('update-platform-zoom-big')"
            >
              110%
            </span>
          </div>
        </li>
        <li class="options-config flex">
          <feather-icon
            icon="LayoutIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ $t("NAVBAR_DROPDOWN_MENU").Appearance }}</div>
          <div class="view-mode user" v-if="!isDesktop">
            <span
              class="icons-tools-wrap icons-tools-wrap-mobile btn-left"
              :class="{ 'view-style-selected-mobile': isListView }"
              @click.stop="listView"
            >
              {{ $t("NAVBAR_DROPDOWN_MENU").View_Type_List }}
            </span>

            <span
              class="icons-tools-wrap icons-tools-wrap-mobile btn-right"
              :class="{ 'view-style-selected-mobile': isListViewDetailed }"
              @click.stop="listViewDetailed"
            >
              {{ $t("NAVBAR_DROPDOWN_MENU").View_Type_Card }}
            </span>
            <span
              v-if="isTabletResolution"
              class="icons-tools-wrap icons-tools-wrap-mobile btn-right"
              :class="{ 'view-style-selected-mobile': isMosaicView }"
              @click.stop="mosaicView"
            >
              Mosaico
            </span>
          </div>
        </li>
        <li class="options-config flex" @click.stop="$emit('change-theme')">
          <feather-icon
            :icon="iconCurrentTheme"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ currentTheme }}</div>
          <div class="swtich-view">
            <vs-switch
              v-model="themeMode"
              vs-value="dark"
              aria-setsize="small"
              @click.prevent=""
            />
          </div>
        </li>
        <li
          class="options-config flex"
          @click.stop="$emit('changeDisplayTicker')"
          v-if="isAuthenticated && !isProfileFree"
        >
          <feather-icon
            :icon="iconShowTicker"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">{{ showTicker }}</div>
          <div class="swtich-view">
            <vs-switch
              v-model="canDisplayTicker"
              aria-setsize="small"
              @click.prevent=""
            />
          </div>
        </li>
        <li
          class="options-config flex"
          v-if="isAuthenticated && isNativeApp && canDisplayBiometry"
          @click.stop="changeBiometryCheckVal"
        >
          <template v-if="isReactApp">
            <feather-icon
              v-if="
                biometryMethod === AppConstants.BIOMETRY_TYPE.TOUCH_ID ||
                biometryMethod === AppConstants.BIOMETRY_TYPE.FINGERPRINT
              "
              icon="TouchIdIcon"
              svgClasses="w-4 h-4"
              class="icons-sub-menu"
            ></feather-icon>
            <feather-icon
              v-if="
                biometryMethod != AppConstants.BIOMETRY_TYPE.TOUCH_ID &&
                biometryMethod != AppConstants.BIOMETRY_TYPE.FINGERPRINT
              "
              icon="FaceIdIcon"
              svgClasses="w-4 h-4"
              class="icons-sub-menu"
            ></feather-icon>
          </template>
          <template v-else>
            <feather-icon
              v-if="biometryMethod === 'other'"
              icon="TouchIdIcon"
              svgClasses="w-4 h-4"
              class="icons-sub-menu"
            ></feather-icon>
            <feather-icon
              v-if="biometryMethod === 'face'"
              icon="FaceIdIcon"
              svgClasses="w-4 h-4"
              class="icons-sub-menu"
            ></feather-icon>
          </template>
          <div class="ml-2">
            {{ $t("NAVBAR_DROPDOWN_MENU").Biometry }}
          </div>
          <div class="swtich-view">
            <vs-switch
              v-model="biometryCheckbox"
              aria-setsize="small"
              @click.prevent=""
            />
          </div>
        </li>
        <li class="options-config flex">
          <feather-icon
            icon="GlobeIcon"
            svgClasses="w-4 h-4"
            class="icons-sub-menu"
          ></feather-icon>
          <div class="ml-2">
            {{ $t("NAVBAR_DROPDOWN_MENU").Language }}
          </div>
          <flags class="flagsview"></flags>
        </li>
        <div class="message-flags">
          <span>{{ $t("MY_ACCOUNT").Text_Language }}</span>
        </div>
      </ul>
      <div
        v-if="!isDesktop"
        class="v-nav-menu-swipe-area"
        v-hammer:swipe.right="onClose"
      ></div>
    </div>
  </div>
</template>

<script>
import AppConstants from "../../appConstants";
import Flags from "../../components/translate/Flags.vue";
import localStorageHelper from "../../helpers/local-storage-helper";
import layoutService from "../../providers/layoutService";
import ChangePassword from "./ChangePassword.vue";
import MyAccount from "./MyAccount.vue";
import UserSignatures from "./UserSignatures.vue";
import UserNotification from "./UserNotification.vue";
import PrivacyPolicy from "../pages/help/PrivacyPolicy.vue";
import ChangeZoom from "../../plugins/ChangeZoom";
import Packages from "./Packages.vue";
import biometryHelper from "@/helpers/biometry-helper";
import checkDeviceTypeHelper from "@/helpers/check-device-type-helper";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";

export default {
  props: {
    displayData: Boolean,
  },
  data() {
    return {
      displayPopupMyAccount: false,
      displayPopupChangePassword: false,
      displayPopupChangeFont: false,
      displayPopupSignatures: false,
      displayPopupPackages: false,
      displayPopupNotification: false,
      displayPopupPrivacyPolicy: false,
      // biometryMethod: '',
      AppConstants,
      // canDisplayBiometry: false,
      biometryCheckbox: false,
    };
  },
  computed: {
    insetStyle() {
      let style = {};
      if (this.$store.state.insetTop)
        style.paddingTop = `${this.$store.state.insetTop}px`;
      if (this.$store.state.insetBottom)
        style.paddingBottom = `${this.$store.state.insetBottom}px`;
      return style;
    },
    isBiometryAvailable() {
      return this.$store.state.isBiometryAvailable;
    },
    canDisplayBiometry() {
      return (
        this.isBiometryAvailable &&
        (this.$store.state.biometryType || this.$store.state.biometrySecrets)
      );
    },
    biometryMethod() {
      return this.$store.state.biometryType;
    },
    isNativeApp() {
      return checkDeviceTypeHelper.isNativeApp();
    },
    isReactApp() {
      return checkDeviceTypeHelper.isReactApp();
    },
    userProfile() {
      return this.$store.state.AppActiveUser.profile;
    },
    isProfileFree() {
      return this.userProfile == AppConstants.USER_PROFILE.FREE;
    },
    canDisplayTicker() {
      return this.$store.state.canDisplayTicker;
    },
    iconShowTicker() {
      if (this.canDisplayTicker == false) {
        return "EyeIcon";
      }
      return "EyeOffIcon";
    },
    showTicker() {
      if (this.canDisplayTicker === false) {
        return this.$t("NAVBAR_DROPDOWN_MENU").Show_Ticker;
      }
      return this.$t("NAVBAR_DROPDOWN_MENU").Hide_Ticker;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    isTabletResolution() {
      return this.windowWidth > 576 && this.windowWidth < 1024;
    },
    canDisplayOnMobileIOS() {
      return this.$store.state.isMobileIOS;
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    iconCurrentTheme() {
      if (this.$store.state.theme === AppConstants.THEME.DARK) {
        return "SunIcon";
      }
      return "MoonIcon";
    },
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
    themeMode: {
      get() {
        return this.$store.state.theme === AppConstants.THEME.DARK;
      },
      set(val) {
        let theme;
        if (val) {
          theme = AppConstants.THEME.DARK;
        } else {
          theme = AppConstants.THEME.LIGHT;
        }
        localStorageHelper.updateTheme(theme);
      },
    },
    biometry() {
      return this.$store.state.biometry;
    },
    currentTheme() {
      if (this.$store.state.theme === AppConstants.THEME.DARK) {
        return this.$t("NAVBAR_DROPDOWN_MENU").Light_Theme;
      }
      return this.$t("NAVBAR_DROPDOWN_MENU").Dark_Theme;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    isListView() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW
      );
    },
    isListViewDetailed() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
    },
    isMosaicView() {
      return (
        this.$store.state.reportViewStyle ===
        AppConstants.REPORT_VIEW_STYLE.MOSAIC
      );
    },
    currentPlatformZoom() {
      return this.activeUserInfo.zoom;
    },
    isPlatformZoomUltraCompact() {
      return this.currentPlatformZoom === "80%";
    },
    isPlatformZoomCompact() {
      return this.currentPlatformZoom === "90%";
    },
    isPlatformZoomDefault() {
      return this.currentPlatformZoom === "100%";
    },
    isPlatformZoomBig() {
      return this.currentPlatformZoom === "110%";
    },
    isZoomCompact() {
      return this.activeUserInfo.zoom === AppConstants.ZOOM.COMPACT;
    },
    isZoomDefault() {
      // console.log('isZoomDefault: ',this.activeUserInfo.zoom)
      return this.activeUserInfo.zoom === AppConstants.ZOOM.DEFAULT;
    },
    isZoomMedium() {
      return this.activeUserInfo.zoom === AppConstants.ZOOM.MEDIUM;
    },
    getUserName() {
      if (!this.activeUserInfo.nome) {
        return "";
      }
      const split = this.activeUserInfo.nome.split(" ");
      return `${split[0]} ${split[split.length - 1]}`;
    },
  },
  async created() {
    // check only is Authenticated
    if (this.isAuthenticated) {
      if (this.isReactApp) {
        await this.checkBiometryData();
      } else {
        biometryHelper.hasBiometry(
          (response) => {
            console.log("[hasBiometry]", response);
            this.$store.dispatch("updateIsBiometryAvailable", true);
            // this.$store.dispatch('updateBiometryType', response);
            this.$store.dispatch(
              "updateBiometryType",
              response === "face" ? "face" : "other"
            );
            // this.biometryMethod = response === 'face' ? 'face' : 'other';

            // this.$store.dispatch('updateBiometry', "1");
            // localStorageHelper.updateBiometry("1");
            this.biometryCheckbox = this.biometry === "1";
          },
          (error) => {
            console.info("Biometrics unavailable:", error);
            // this.biometryMethod = '';
            this.$store.dispatch("updateIsBiometryAvailable", false);
          }
        );
      }
    }
  },
  mounted() {
    if (this.$store.state.insetTop || this.$store.state.insetBottom) {
      let styleTag = document.getElementById("menu-user-overrides");
      if (!styleTag) {
        styleTag = document.createElement("style");
        styleTag.id = "menu-user-overrides";
        document.head.appendChild(styleTag);
      }
      styleTag.textContent = `
      .body-user .mobile-content-options{
        top: ${this.$store.state.insetTop}px !important;
        bottom: ${this.$store.state.insetBottom}px !important;
      }

    `;
    }
  },
  methods: {
    async checkBiometryData() {
      try {
        // check only if is authenticated
        // TODO - getBiometrySecret, se vier dados ativo o checkbox, se não não mostro
        console.log("[waitCheckHasBiometry] init menu user mobile");
        const hasBiometrySecrets = await biometryHelper.waitHasBiometrySecret();
        console.log("[hasBiometrySecrets]", hasBiometrySecrets);
        if (hasBiometrySecrets) {
          this.biometryCheckbox = true;
        }
        // if (biometrySecrets) {
        //  this.canDisplayBiometry = true;
        // }
        const biometryType = await biometryHelper.waitCheckHasBiometry(); // this function will update biometryMethod
        console.log("[biometryType]", biometryType);
        if (biometryType) {
          // this.canDisplayBiometry = true;
          // this.biometryMethod = biometryType;
        } else {
          console.info("biometryType unavailable");
          // this.biometryMethod = '';
        }
      } catch (error) {
        console.info("biometryType unavailable:", error);
        // this.biometryMethod = '';
      }
      // this.biometryCheckbox = this.biometry === "1";

      // biometryHelper.hasBiometry(
      //   (response) => {
      //     this.biometryMethod = response === 'face' ? 'face' : 'other';
      //   },
      //   (error) => {
      //     console.info('Biometrics unavailable:', error);
      //     this.biometryMethod = '';
      //   }
      // );
    },
    async changeBiometryCheckVal() {
      this.biometryCheckbox = !this.biometryCheckbox;
      // console.log('[changeBiometryCheckVal]', val);
      console.log(
        "[changeBiometryCheckVal][biometryCheckbox]",
        this.biometryCheckbox
      );
      // alert('biometry set value: ' + val);
      if (this.biometryCheckbox) {
        // biometryHelper.show(this.successShowBiometry, this.errorShowBiometry);
        try {
          // const biom = await biometryHelper.waitDisplayBiometry();
          this.successShowBiometry();
        } catch (error) {
          console.log("[setBiometry]", error);
          this.errorShowBiometry();
        }
        // biometryHelper.show(this.successShowBiometry, this.errorShowBiometry);
      } else {
        localStorageHelper.updateBiometry("0");
        await biometryHelper.waitRemoveBiometrySecret();
      }
    },
    async successShowBiometry() {
      const refreshToken = localStorageHelper.getCurrentUser().refreshToken;
      if (this.isReactApp) {
        try {
          const secret = await biometryHelper.waitSaveBiometrySecret(
            refreshToken
          );
          console.log(secret);
          if (secret) {
            this.successRegisterBiometry();
          } else {
            console.log(
              "[successShowBiometry][registerSecret][fail] não foi possivel identificar a biometria"
            );
            this.errorRegisterBiometry();
          }
        } catch (error) {
          console.log("[successShowBiometry][registerSecret][error]", error);
          this.errorRegisterBiometry();
        }
      } else {
        try {
          biometryHelper.registerSecret(
            refreshToken,
            this.successRegisterBiometry,
            this.errorRegisterBiometry
          );
        } catch (error) {
          console.log("[successShowBiometry][registerSecret][error]", error);
        }
      }
    },
    errorShowBiometry(error) {
      // alert("Erro biometria " + error.message);
    },
    successRegisterBiometry() {
      localStorageHelper.updateBiometry("1");
    },
    errorRegisterBiometry(error) {
      // alert("errorRegisterBiometry " + error.message);
      if (error && error.message) {
        messagesNotifyHelper.errorNotify("Biometria", error.message);
      } else {
        messagesNotifyHelper.errorNotify(
          "Biometria",
          "Não foi possível confirmar a biometria"
        );
      }
    },
    openUserSignaturesMobile() {
      this.displayPopupSignatures = !this.displayPopupSignatures;
    },
    openPlans() {
      this.displayPopupPackages = !this.displayPopupPackages;
    },
    onClose() {
      this.$emit("back");
    },
    updateZoomCompact() {
      ChangeZoom.setCompact();
    },
    updateZoomDefault() {
      ChangeZoom.setDefault();
    },
    updateZoomMedium() {
      ChangeZoom.setMedium();
    },
    updateZoomBig() {
      ChangeZoom.setBig();
    },
    listView() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW
      );
      this.saveReportViewStyle(AppConstants.REPORT_VIEW_STYLE.LISTVIEW);
    },
    listViewDetailed() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
      this.saveReportViewStyle(
        AppConstants.REPORT_VIEW_STYLE.LISTVIEW_DETAILED
      );
    },
    changeBiometry() {
      console.log("change Biometry..." + this.biometry);
      // localStorageHelper.updateBiometry(this.biometry);
    },
    mosaicView() {
      this.$store.dispatch(
        "reportListStyle",
        AppConstants.REPORT_VIEW_STYLE.MOSAIC
      );
      this.saveReportViewStyle(AppConstants.REPORT_VIEW_STYLE.MOSAIC);
      this.saveReportViewStyle(AppConstants.REPORT_VIEW_STYLE.MOSAIC);
    },
    saveReportViewStyle(val) {
      localStorageHelper.updateReportViewStyle(val);

      const form = {
        viewstyle: val,
      };
      if (this.isAuthenticated) {
        layoutService.saveLayout(form, new URLSearchParams());
      }
    },
  },
  components: {
    MyAccount,
    Flags,
    ChangePassword,
    UserSignatures,
    UserNotification,
    PrivacyPolicy,
    Packages,
  },
};
</script>

<style></style>
